module.exports = __webpack_public_path__ + "img/icon.f303db7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/icon.png
// module id = ZXGu
// module chunks = 1